export var ANIMATION_DURATION_FADE_OUT = 300;
export var ANIMATION_DURATION_SLIDE = 500;
export var VISIBILITY_DURATION = 5000;
//# sourceMappingURL=constants.js.map